import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "content-dashboard h-100 w-100 pb-5",
  id: "login-admin"
}
const _hoisted_4 = { class: "content-dashboard__reports tw-mt-[30px]" }
const _hoisted_5 = { class: "content-dashboard__reports__section-table" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "content-dashboard__reports__section-table__tittle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "PROFILE SETTINGS")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "content-dashboard__reports__section-table__profile d-flex tw-justify-center"
}
const _hoisted_9 = { class: "content-dashboard__reports__section-table__profile__image mb-5" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "upload-btn-wrapper" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", { class: "boton-standar-rw" }, "Selecciona una foto", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "d-flex justify-content-center" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "form-group d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }),
  /*#__PURE__*/_createElementVNode("span", null, "Name ")
], -1)
const _hoisted_21 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_22 = { class: "form-group d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-id-card" }),
  /*#__PURE__*/_createElementVNode("span", null, "Last Name")
], -1)
const _hoisted_24 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "form-group d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building" }),
  /*#__PURE__*/_createElementVNode("span", null, "Company Name")
], -1)
const _hoisted_28 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_29 = { class: "form-group d-flex align-items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-volume" }),
  /*#__PURE__*/_createElementVNode("span", null, "Phone Number")
], -1)
const _hoisted_31 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_32 = { class: "form-group d-flex align-items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }),
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_34 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_35 = { class: "form-group d-flex align-items-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag-usa" }),
  /*#__PURE__*/_createElementVNode("span", null, "Estate")
], -1)
const _hoisted_37 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "form-group d-flex align-items-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt" }),
  /*#__PURE__*/_createElementVNode("span", null, "Country")
], -1)
const _hoisted_41 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "form-group d-flex align-items-center" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createElementVNode("span", null, "Addressess")
], -1)
const _hoisted_45 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "form-group d-flex align-items-center" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code" }),
  /*#__PURE__*/_createElementVNode("span", null, "Zip Code")
], -1)
const _hoisted_49 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 2,
  class: "form-group d-flex align-items-center"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code" }),
  /*#__PURE__*/_createElementVNode("span", null, "License number")
], -1)
const _hoisted_53 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_54 = { class: "form-group d-flex align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex justify-start tw-items-center tw-w-1/3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-unlock-alt" }),
  /*#__PURE__*/_createElementVNode("span", null, "Password")
], -1)
const _hoisted_56 = { class: "tw-flex items-center tw-w-2/3" }
const _hoisted_57 = ["type", "disabled"]
const _hoisted_58 = { class: "save-changes d-flex justify-content-center pt-4 pb-4 tw-gap-9" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "SAVE", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock mr-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading, {
      active: _ctx.loaderConfig.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
      "can-cancel": false,
      loader: 'dots',
      "is-full-page": _ctx.loaderConfig.fullPage
    }, null, 8, ["active", "is-full-page"]),
    (_ctx.userRole)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_TopBar),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                (_ctx.usersession.role == 'Realtor')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (!_ctx.usersession?.picture && _ctx.usersession.role === 'Realtor')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "img-profile",
                              src: require('@/assets/Images/profile3.png'),
                              alt: ""
                            }, null, 8, _hoisted_10))
                          : _createCommentVNode("", true),
                        (_ctx.usersession?.picture && _ctx.usersession?.role == 'Realtor')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              class: "img-profile tw-h-[150px]",
                              src: 'http://api.realtortools.org/uploads/' + _ctx.usersession?.picture,
                              alt: ""
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("input", {
                              class: "upload-file-buton",
                              type: "file",
                              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleImageUpload && _ctx.handleImageUpload(...args)))
                            }, null, 32)
                          ]),
                          _createElementVNode("button", {
                            class: "upload-Image tw-ml-5 tw-pr-3 tw-pl-3",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
                          }, _hoisted_16)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("form", {
                    onSubmit: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
                  }, [
                    (_ctx.userRole != 'Title Company')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "username",
                                class: "form-control tw-w-full",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.userForm.$model.username) = $event)),
                                required: ""
                              }, null, 512), [
                                [_vModelText, _ctx.v$.userForm.$model.username]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "lastname",
                                class: "form-control tw-w-full",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.userForm.$model.lastname) = $event)),
                                required: ""
                              }, null, 512), [
                                [_vModelText, _ctx.v$.userForm.$model.lastname]
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.userRole == 'Title Company')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "companyname",
                                class: "form-control tw-w-full",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.userForm.$model.companyname) = $event)),
                                required: ""
                              }, null, 512), [
                                [_vModelText, _ctx.v$.userForm.$model.companyname]
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "lastname",
                          class: "form-control tw-w-full",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.userForm.$model.phonenumber) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.v$.userForm.$model.phonenumber]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          id: "email",
                          class: "form-control tw-w-full",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.userForm.$model.email) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.v$.userForm.$model.email]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "estate",
                          class: "form-control tw-w-full",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.userForm.$model.state) = $event)),
                          disabled: !_ctx.v$.userForm.state.$disabled,
                          required: ""
                        }, null, 8, _hoisted_38), [
                          [_vModelText, _ctx.v$.userForm.$model.state]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "country",
                          class: "form-control tw-w-full",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.userForm.$model.country) = $event)),
                          disabled: !_ctx.v$.userForm.country.$disabled,
                          required: ""
                        }, null, 8, _hoisted_42), [
                          [_vModelText, _ctx.v$.userForm.$model.country]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "addressess",
                          class: "form-control tw-w-full",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.userForm.$model.address) = $event)),
                          disabled: !_ctx.v$.userForm.address.$disabled,
                          required: ""
                        }, null, 8, _hoisted_46), [
                          [_vModelText, _ctx.v$.userForm.$model.address]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "zipcode",
                          class: "form-control tw-w-full",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.userForm.$model.zipcode) = $event)),
                          disabled: !_ctx.v$.userForm.zipcode.$disabled,
                          required: ""
                        }, null, 8, _hoisted_50), [
                          [_vModelText, _ctx.v$.userForm.$model.zipcode]
                        ])
                      ])
                    ]),
                    (_ctx.usersession.role == 'Realtor' || _ctx.usersession.role == 'MLO')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "zipcode",
                              class: "form-control tw-w-full",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.userForm.$model.licensenumber) = $event)),
                              required: ""
                            }, null, 512), [
                              [_vModelText, _ctx.v$.userForm.$model.licensenumber]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("div", _hoisted_56, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.v$.userForm.password.show ? 'text':'password',
                          id: "password",
                          class: _normalizeClass(["form-control tw-w-full", { 'color-change': _ctx.changePasswordColor }]),
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.userForm.$model.password) = $event)),
                          disabled: _ctx.disablePassword,
                          required: ""
                        }, null, 10, _hoisted_57), [
                          [_vModelDynamic, _ctx.v$.userForm.$model.password]
                        ]),
                        (!_ctx.v$.userForm.password.show)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "tw-absolute tw-right-[35px] tw-top-1/2 -tw-translate-y-1/2 tw-text-[#339366] tw-hover:bg-blue-700 tw-font-bold tw-py-1 tw-px-4 tw-rounded",
                              type: "button",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.userForm.password.show = true))
                            }, "show"))
                          : _createCommentVNode("", true),
                        (_ctx.v$.userForm.password.show)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "tw-absolute tw-right-[35px] tw-top-1/2 -tw-translate-y-1/2 tw-text-red-500 tw-hover:bg-blue-700 tw-font-bold tw-py-1 tw-px-4 tw-rounded",
                              type: "button",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.userForm.password.show = false))
                            }, "hide"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleDisablePassword()))
                      }, [
                        _hoisted_60,
                        _createTextVNode("Change Password ")
                      ])
                    ])
                  ], 32)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}